import React from 'react';
import MypagePaymentHistoryDetailContainer from 'containers/MypagePaymentHistoryDetailContainer';

export default function MypagePaymentHistoryDetailPage() {
  return <MypagePaymentHistoryDetailContainer />;
}
